import React, {Component} from "react";
import { connect } from 'react-redux';

import MusicGrid from '../../components/MusicGrid';
import Resume from '../../components/Resume';
import Spinner from './../../components/Spinner';
import MusicUtils from "../../actions/musica/music-actions";
import MusicActions from '../../components/MusicActions';
import { fetchLoginDynamic } from '../../reducers/user';
import { setResumeData } from '../../actions/resume';
import { doPGMRadio } from '../../actions/musica/player-shared-action-creators';
import { playFullMedia } from '../../actions/playmedia';
import * as api from '../../requests/loader';
import Placeholder from '../../containers/Placeholder';

class ArtistRadioList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseButtonInfo: null,
      user: props.user,
      isFetching: false,
      artistRadios: [],
      selectedRadio: {},
      pgm: null,
      loading: false
    };
    this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
    this.intervalRadios = null;
    this.handlePlay = this.handlePlay.bind(this);
    this.toggleFollow = this.toggleFollow.bind(this);
  }

  onFocusCardHandler(data, index) {
    if (this.idTimeout) {
      clearTimeout(this.idTimeout);
    }
    this.idTimeout = setTimeout(()=>{
      const elements = document.getElementsByClassName('focused');
      if(elements.length > 0)
        elements[0].classList.remove('focused');

      const selEl= document.getElementById(`card-${data.id}`);
      console.log(selEl);
      if(selEl){
        selEl.classList.add("focused");
      }
      const itemData = {
        title: data.artist,
        year: data.name,
        rating: data.rating_code,
        category: data.artist,
        duration: data.title,
        showBack: false,
        purchaseButtonInfo: true,

      };
      this.setState({
        selectedRadio: data
      });
      this.props.setResumeData({...itemData, overWrite: true});
    }, 500);
  }

  parseItem = items =>
    items.map(i => {
      i.id = i.entity_id;
      i.name = i.station;
      i.image = i.img || null;

      return i;
  });

  fetchArtistRadios() {
    this.setState({ loading: true});
    const artistId = this.props.match.params.id;
    api.getArtistRadiosLive({
        artistId
    })
    .then(response => {
        this.setState({ loading: false});
        const { components } = response;
        this.setState({ artistRadios: this.parseItem(components[2].properties.items) });
    })
    .catch(err => {
      this.setState({ loading: false});
        console.log('Fail artist radios: ' + err);
    });
  }

  toggleFollow(){
    const that = this;
    MusicUtils.toggleFavorite(this.state.selectedRadio, this.props.user.musicUser).then((toggleValue) => {
      const playlistDetail = {...that.state.playlistDetail, isFollowing: toggleValue}
      that.setState({ playlistDetail });
    }).catch(err => {
      const playlistDetail = {...that.state.playlistDetail, isFollowing: err}
      this.setState({ playlistDetail });
    });
  }

  sendToPlay = (pgm) => {
    if(pgm) {
      this.props.playFullMedia({
        playerstate: 'PLAYING',
        source: {
          audiosource: pgm.media.video_url
        },
        ispreview: false,
        islive: false,
        ispip: false,
      });
    }
  }

  handlePlay(){
    let pgm;
    if(!this.state.selectedRadio.url) {
      MusicUtils.getRadioDetailFromCard(this.state.selectedRadio.id, this.props.user.musicUser).then(radio =>{
        pgm = this.props.onPlayRadio(radio.url, radio);
        this.sendToPlay(pgm);
      });
    } else {
      pgm = this.props.onPlayRadio(this.state.selectedRadio.url, this.state.selectedRadio);
      this.sendToPlay(pgm);
    }
  }

  componentWillMount() {
    if(this.props.user.musicUser === undefined){
      this.props.fetchLoginDynamic(this.state.user.email);
      this.setState({user: this.props.user});
    }
  }

  componentDidMount(){
    if (this.props.user.musicUser !== undefined){
      this.fetchArtistRadios(this.props.user.musicUser)
    }

  }

  componentWillReceiveProps(nextProps){
    if(nextProps.user.musicUser){
      this.fetchArtistRadios(nextProps.user.musicUser)
    }
  }

  componentWillUnmount(){
    clearInterval(this.intervalRadios);
  }

  render() {
    return (
      <div className="radios-container-inter">
        <Resume />
        {this.state.loading  ? <Spinner /> : null}
        {!this.state.loading && this.state.artistRadios.length === 0 ?
        <Placeholder type={'artistRadiosList'}/>
        : null}
        <MusicGrid
          items={this.state.artistRadios}
          gridType="radio"
          service="Radios"
          type="square"
          onFocusHandler={this.onFocusCardHandler}
        />
        <MusicActions
          actionType="radios"
          buttonData={this.state.selectedRadio}
          blueAction={this.handlePlay}
          yellowAction={this.toggleFollow}
          isHidden={true}
          device={MusicUtils.getMusicDevice()}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({ user: state.user, playerMusica: state.playermusica });
const mapDispatchToProps = dispatch => ({
  fetchLoginDynamic: (email) => dispatch(fetchLoginDynamic(email)),
  setResumeData: (itemData) => dispatch(setResumeData(itemData)),
  onPlayRadio: (index,state) => dispatch(doPGMRadio(index, state)),
  playFullMedia: (pgm) => dispatch(playFullMedia(pgm))
});
export default connect(mapStateToProps, mapDispatchToProps)(ArtistRadioList);



// WEBPACK FOOTER //
// ./src/components/ArtistRadioList/index.jsx